'use client';
import React, { useEffect, useState } from 'react';
import ServiceLayout from '../../plates/MyPlatesContent/ServiceLayout';
import PageWrapper from '@/components/general/PageWrapper';
import ViewportWrapper from '@/components/structure/ViewportWrapper';
import { PageHero } from '@/components/general/PageHero';
import SingleServiceHero from './SingleServiceHero';
import config, { subCategoryIdList, TRIGGERS } from '@/api/global';
import ServiceDetails from './ServiceDetails';
import ServiceHistory from './ServiceHistory';
import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
import HistoryComponent from './HistoryComponenet';
import { useLayoutContext } from '@/context/LayoutContext';
import {
  getViolations,
  historyType,
  payType,
  ResponseType,
  ServiceSubCategory,
  serviceType,
} from '@/commonTypes';
import styles from './styles.module.css';
import AiInsight from './AiInsight';
import SampleBlogs from '../../home/HomeContent/SampleBlogs';
import Api from '@/api';
import { useSearchParams } from 'next/navigation';
import CookieFunction from '@/functions/cookieFunction';

interface HistoryResponse {
  response: historyType[];
  total: number;
}

export default function SingleServiceContent({
  slug,
  data,
  historyData,
  count = 0,
  key,
  limit = 10,
}: {
  slug?: string | number;
  data?: ServiceSubCategory;
  historyData?: any;
  count?: number;
  key?: string;
  limit: number | string;
}) {
  const [totalHistoryCount, setTotalHistoryCount] = useState(count);
  const { activeCar, setTrigger, paymentFunction } = useLayoutContext();
  const [violations, setViolations] = useState([]);
  const [violationCount, setViolationCount] = useState(0);
  const [history, setHistory] = useState<any>([]);
  const [imagesService, setImageService] = useState();
  const violationService = data?.key == subCategoryIdList.vehicle_fines;
  const activePlates = data?.key == subCategoryIdList.user_active_license_plates;
  const noAuth = data?.key == subCategoryIdList.fines_without_identity_verification;
  const searchParams = useSearchParams();
  const [loadingViolations, setLoadingViolations] = useState<boolean>(false);
  const callBackResponseId = searchParams.get('response_id');

  console.log('callBackResponseId====', callBackResponseId);

  useEffect(() => {
    setHistory(history);
    if (violationService) {
      getImageService();
    }
  }, [history]);

  useEffect(() => {
    const isLogin = CookieFunction('get', config.tokenName);
    console.log('isLogin==', isLogin);
    if (callBackResponseId && !isLogin && noAuth) {
      Api.fetchNoAuth({ params: { response_id: callBackResponseId } })
        .then((res) => {
          console.log('resnoauth==', res);
          const value = Object.values(res?.data?.response ?? {})[0] as HistoryResponse | undefined;

          console.log('value==', value);
          let newresponse;

          newresponse = value?.response;
          setHistory(newresponse);
          setTotalHistoryCount(value?.total ?? 0);
        })
        .catch((err) => {});
    }
  }, [searchParams]);

  const getImageService = () => {
    Api.serviceSubCategoryList({
      params: { key: subCategoryIdList.vehicle_fines_image },
    })
      .then((res) => {
        setImageService(res?.data?.response?.[0]);
      })
      .catch((err) => {
        console.error('getImageService failed:', err);
      });
  };
  console.log('imagesService==', imagesService);

  console.log('plate========', TransformPlateNumber(' شخصي  ايران 60 ــ  196ي38'));
  console.log('data======', data, history, count, key);

  const getViolations: getViolations = (start = 0, historyId) => {
    let key = '';
    if (violationService) {
      key = 'ViolationItems';
    }
    if (activePlates) {
      key = 'LicensePlates';
    }
    setLoadingViolations(true);
    Api.serviceHistory({
      params: {
        service_identifier: data?.key,
        response_id: historyId,
        start: start,
        limit: 2,
      },
    })
      .then((res) => {
        console.log('vvvvvvvvvvv', res);

        let historyArray = [...history];
        let index = historyArray?.findIndex((x) => x.id == historyId);

        // historyArray[index].violations = response;
        if (start == 0) {
          historyArray[index].items = res?.data?.response?.[key]?.response;
        } else {
          historyArray[index].items = historyArray[index].items?.concat(
            res?.data?.response?.[key]?.response,
          );
        }
        historyArray[index].items_count = res?.data?.response?.[key]?.total;
        setHistory(historyArray);
        setLoadingViolations(false);
      })
      .catch((err) => {
        setLoadingViolations(false);
      });
  };
  useEffect(() => {
    if (
      violationService &&
      // || activePlates
      history?.[0]?.id
    ) {
      getViolations(0, history?.[0]?.id);
    }
  }, [history?.[0]?.id, data?.key]);
  console.log('data.key=========', data?.key, violationCount);
  const getMoreViolations = (currentLength: number, historyId?: string | number) => {
    console.log('historyId========', currentLength, historyId);
    historyId && getViolations(currentLength, historyId);
  };

  const callBackHistory = (x?: any) => {
    getHistoryList();
  };
  const getHistoryList = (start = 0) => {
    Api.serviceHistory({
      params: {
        service_identifier: data?.key,
        start: start,
        limit: limit,
      },
    })
      .then((res) => {
        const value = Object.values(res?.data?.response ?? {})[0] as HistoryResponse | undefined;

        console.log('value==', value);
        let newresponse;
        if (start == 0) {
          newresponse = value?.response;
        } else {
          newresponse = history?.concat(value?.response);
        }
        setHistory(newresponse);
        setTotalHistoryCount(value?.total ?? 0);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getMoreHistory = () => {
    getHistoryList(history?.length);
  };

  useEffect(() => {
    getHistoryList();
  }, []);

  console.log('history==', history);
  return (
    <ServiceLayout
      bannerTitle="پیش از رسیدن به حد مجاز اقدام کنید"
      bannerText="با فعال‌سازی اعلان امتیاز منفی، پیش از توقیف گواهینامه به‌موقع هشدار بگیرید و وضعیت پلاک خود را کنترل کنید."
    >
      <PageWrapper>
        <ViewportWrapper className={`w-full`}>
          <PageHero>
            <SingleServiceHero
              data={data}
              onClick={paymentFunction}
              callBackHistory={callBackHistory}
            />
          </PageHero>
        </ViewportWrapper>
      </PageWrapper>
      <PageWrapper className={`section-light mt-0`}>
        <ViewportWrapper className={`container`}>
          <ServiceDetails
            serviceKey={data?.key}
            // data={
            //   history?.map((x: historyType) => {
            //     return { ...x, violations: violationService ? violations : null };
            //   })?.[0]
            // }
            data={history?.[0]}
            onClickPay={paymentFunction}

            getMoreViolations={getMoreViolations}
            subCategoryInfo={data}
            lastHistoryInfo={history?.[0]}
            callBackHistory={callBackHistory}
            imagesService={imagesService}
            loadingViolations={loadingViolations}
          />
          <HistoryComponent
            history={history}
            count={totalHistoryCount}
            getMoreHistory={getMoreHistory}
          >
            <ServiceHistory
              data={data}
              history={history?.map((x: historyType) => {
                return {
                  ...x,
                  plate: violationService
                    ? {
                        plate: TransformPlateNumber(data?.response?.plate_char),
                        name: `پژو ۲۰۶ — ${activeCar?.name} `,
                        debt: data?.response?.inquire_price,
                        hasDebt: true,
                        statusLabel: 'دارای بدهی',
                      }
                    : null,
                  // violations: x?.violations ? x?.violations : null,
                  // violationsCount: x?.violationsCount ? x?.violationsCount : 0,
                };
              })}
              count={totalHistoryCount}
              headerType={violationService ? 'violation' : 'normal'}
              // violationCount={item?.violationsCount}
              getMoreViolations={getMoreViolations}
              getViolations={getViolations}
              loadingViolations={loadingViolations}
              // onClickPay={paymentFunction}
            ></ServiceHistory>
          </HistoryComponent>
        </ViewportWrapper>
      </PageWrapper>
    </ServiceLayout>
  );
}
